module.exports = __webpack_public_path__ + "img/E2 CP5.5c769e05.png";